import { currentUser, HomeboundUser } from "@homebound/auth-components";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDeepLink } from "src/hooks/useDeepLink";
import { PdfRoutes } from "src/PdfRoutes";
import { PageLayout } from "src/routes/layout/PageLayout";
import { PdfLayout } from "src/routes/layout/PdfLayout";
import { Routes } from "./Routes";

/** LEGACY ROUTING — entry for URLs not matched by `src/routing/Router.tsx` migrated routes. See `src/routing/README.md`. */
export function App() {
  const [isAuthenticating, setIsAuthenticating] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState<HomeboundUser>();
  const location = useLocation();
  const isPdfRoute = location.pathname.startsWith("/pdf");

  useEffect(() => {
    onLoad().catch(console.error);
  }, []);

  async function onLoad() {
    const { data: user } = await currentUser();
    setUser(user);
    setIsAuthenticated(user !== undefined);
    setIsAuthenticating(false);
  }

  const authProps = { isAuthenticated, setIsAuthenticated, user, setUser };
  const routes = <Routes authProps={authProps} />;

  useDeepLink(isAuthenticated, isAuthenticating);

  if (isAuthenticating) {
    return <div />;
  }

  if (isPdfRoute) {
    // PDF routes use a dedicated layout and bypass PageLayout + Routes.
    // Can be accessed while either authed or unauthed-to-amplify
    return (
      <PdfLayout>
        <PdfRoutes />
      </PdfLayout>
    );
  }

  if (isAuthenticated) {
    return <PageLayout>{routes}</PageLayout>;
  }

  // Unauthenticated, non-PDF routes (sign-in, OAuth callback, etc.) — no PageLayout chrome.
  return routes;
}
